import { AxiosError } from 'axios';

import { IDataResponseError } from '@shared/model/types/dataResponse.inteface';

export const handleStatusError = (data: IDataResponseError | null | undefined, btnText: string) => {
    if (data?.status === 'error' || data.status >= 400) {
        // @ts-ignore
        swal({
            text: data.message ?? 'Something went wrong',
            cancel: false,
            confirm: true,
            button: {
                text: btnText,
                value: true,
                visible: true,
                className: 'btn btn-secondary',
            },
        });
    }
};

export const handleErrorInsideQuery = (error: AxiosError<IDataResponseError>, btnText: string) => {
    console.error('error in pay widget by card: ', error);

    if (error.response?.data?.status === 'error') {
        handleStatusError(error.response.data, btnText);
        return;
    }

    const fallbackError: IDataResponseError = {
        status: 'error',
        message: error.message,
    };

    handleStatusError(fallbackError, btnText);
};
